var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconBn = function SvgIconBn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M12 23.998c6.627 0 11.998-5.372 11.998-11.999C23.998 5.373 18.627.002 12 .002S.002 5.373.002 12c0 6.626 5.372 11.998 11.998 11.998"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M1.61 6.001A12 12 0 0 0 .401 8.918l20.066 11.585A12 12 0 0 0 22.391 18z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFDA44"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.998 1.61C13.198-1.164 7.278-.24 3.531 3.496l20.066 11.585c1.362-5.113-.798-10.701-5.599-13.473M6 22.39c4.801 2.772 10.72 1.848 14.467-1.888L.402 8.917C-.96 14.03 1.199 19.618 6 22.39"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#D80027"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.39 10.696a3.39 3.39 0 1 1-6.374-1.613 4.173 4.173 0 1 0 5.966 0c.26.48.408 1.03.408 1.613"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.783 6.783h-1.565v7.825h1.565z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.608 8.348H9.392c0 .36.313.652.673.652h-.021c0 .36.292.652.652.652 0 .36.292.652.652.652h1.304c.36 0 .652-.292.652-.652.36 0 .652-.292.652-.652h-.021c.36 0 .673-.292.673-.652M15.652 15.13H8.349v1.565h7.303z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.694 15.65h-3.13v1.566h3.13zM10.435 15.65h-3.13v1.566h3.13z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgIconBn;